<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Liste",
          icon: "bi bi-list",
          route: "attendances-index",
        },
        {
          label: "Créer",
          icon: "bi bi-plus-square",
          route: "attendances-create",
        },
        {
          label: "Salaires",
          icon: "bi bi-cash-coin",
          route: "attendances-salaries",
        },
      ],
    };
  },
};
</script>
